module.exports = __webpack_public_path__ + "static/media/bryanmuliw.afac8cc9.jpg";